import { User } from 'generate/types';

export function getUserName(transporter: User['transporter'], firstName: User['first_name'], lastName: User['last_name']) {
	const names = `${firstName || ''} ${lastName || ''}`.trim();
	const transporterName = `${transporter || ''}`.trim()
	return names || transporterName;
}
